/* eslint-disable jsx-a11y/anchor-is-valid */
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ITrafficLightData } from '../api/TrafficLights';
import './TrafficLight.css'


export interface ITrafficLight {
  intl: any,
  data: ITrafficLightData;
}

const TrafficLight: React.FunctionComponent<ITrafficLight> = (props: ITrafficLight) => {
  const [showMessage, setShowMessage] = useState(false);
  let color = props.data.color;
  let icon = 'check' as IconProp;
  let text = 'trafficlights.header.' + props.data.color;
  if(props.data.color === 'red') {
    color = 'red';
    icon = 'exclamation-circle';
  } else if (props.data.color === 'yellow') {
    color = 'orange';
    icon = 'exclamation-triangle';
  }

  return (
    <div>
      {props.data.color &&
        <div className={"trafficlight " + props.data.color}>
          <div className={ showMessage ?  "d-flex flex-row open" : "d-flex flex-row"}>
            <div>
            {props.data.color &&
              <FontAwesomeIcon className="icon" icon={icon} color={"var(--serty-" + color + ")"}/>}
            { props.data.type ? props.intl.formatMessage({id: 'trafficlights.header.' + props.data.type}) + " " + props.intl.formatMessage({id: text}) : ""}
            { showMessage && props.data.msg.errorID !== 0 &&
              <div className="error-modal">
                <a href="#" className="modal-close-button" onClick={(e) => {e.stopPropagation(); setShowMessage(false);}}>X</a>
                <div onClick={() => {setShowMessage(false);}} >
                  <div className="error-modal-header">{ props.intl.formatMessage({id: 'trafficlights.error.' + props.data.msg.errorID}) }</div>
                  <div className="error-modal-content">{ props.data.msg.value }</div>
                </div>
              </div>
            }
            </div>
            {(props.data.msg.errorID !== 0) &&
              <a href="#" className={"btn-open "} onClick={(e) => {e.stopPropagation(); if(props.data.msg.errorID !== 0) setShowMessage(!showMessage);}}>
                <FormattedMessage id="trafficlights.showmore"/>
                <FontAwesomeIcon className="icon" icon="chevron-down"/>
              </a>}
          </div>
        </div>
      }
    </div>
  )
}

export default injectIntl(TrafficLight);